import { useFormikContext } from 'formik'
import React from 'react'

import { Heading6 } from '@ui/Typography'

import { useCategorySizesReadContext } from '@utils/CategorySizesContext'

import { Box } from '@shared/components/Box'
import { QuestionFieldFactory } from '@shared/templates/Test/TestFields/TestFields'

import { YearlyKycUpdateDetailsFormValues } from './YearlyKycUpdateDetailsForm'

export const YearlyKycTestForm: React.FC = () => {
  const { values } = useFormikContext<YearlyKycUpdateDetailsFormValues>()
  const { categorySizes } = useCategorySizesReadContext()
  const allQuestions = (values.accountKycTest?.sections || []).flatMap(
    (section) => section.questions
  )

  return (
    <Box flex direction='column' gap='x24' fullWidth>
      {(values.accountKycTest?.sections || []).map((section) => (
        <Box
          key={section.id}
          flex
          direction='column'
          gap='x16'
          p='x24'
          bg='surface-white-smoke-0'
          radius='x16'
          shadow='e3'
          fullWidth
        >
          <Heading6 medium>{section.name}</Heading6>
          <QuestionFieldFactory
            section={section}
            allQuestions={allQuestions}
            categorySizes={categorySizes}
            documents={[]}
          />
        </Box>
      ))}
    </Box>
  )
}
